import { useEffect, useState } from "react"
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import MUIDataTable from "mui-datatables"
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined"

const initialState = {
  tipo: "",
  calle: "",
  numero_calle: "",
  descripcion: "",
  codigo_postal: "",
  piso: "",
  dpto: "",
  monoblock: "",
  barrio: "",
  manzana: "",
  casa: "",
  localidad: "",
  coordenadas: "",
  id: "",
  id_departamento: "",
  id_provincia: "",
  id_pais: "",
  domicilio_electronico: "",
  domicilio_contractual: "",
  latitud: "",
  longitud: "",
}


  const formatAddress = (address) => {
    const parts = [];
  
    if (address.calle) parts.push(address.calle);
    if (address.numero_calle) parts.push(address.numero_calle + "\n");
    if (address.piso) parts.push(`Piso: ${address.piso}`);
    if (address.dpto) parts.push(`Dpto: ${address.dpto}`);
    if (address.monoblock) parts.push(`Monoblock: ${address.monoblock}\n`);
    if (address.manzana) parts.push(`Manzana: ${address.manzana}`);
    if (address.casa) parts.push(`Casa: ${address.casa}`);
    if (address.barrio) parts.push(`Barrio: ${address.barrio}\n`);
    if (address.localidad) parts.push(address.localidad);
    if (address.id_departamento) parts.push(address.id_departamento + `\n`);
    if (address.id_provincia) parts.push(address.id_provincia);
    if (address.id_pais) parts.push(address.id_pais);  
    return parts.join(" ").trim();
  };

const DomiciliosDialog = ({ onSave, onClose, itemCrud, itemsCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState)
  const [domicilios, setDomicilios] = useState([])
  const [departamentos, setDepartamentos] = useState([])
  const [provincias, setProvincias] = useState([])
  const [paises, setPaises] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)

  useEffect(() => {
    console.log("########### INGRESANDO A COMPONENTE DOMICILIOS DIALOG ###########\n")
    console.log("actionCrud: ", actionCrud)
    if (actionCrud === "create") {
      setItemCrudLocal(initialState)
    } else {
      setItemCrudLocal(itemCrud)
    }
    const _itemCrud = itemsCrud
    if (_itemCrud.length > 0) {
      _itemCrud.forEach((item) => {
        item.tipo = item.tipo.toUpperCase()
      })
      setDomicilios(_itemCrud)
    } else {
      setDomicilios([])
    }
  }, [actionCrud, itemCrud, itemsCrud])



  useEffect(() => {
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  
    if (itemsCrud.length > 0) {
      const firstDomicilio = itemsCrud[0]; // Seleccionar el primer domicilio
      setItemCrudLocal({
        tipo: firstDomicilio.tipo,
        numero_calle: firstDomicilio.numero_calle,
        calle: firstDomicilio.calle ? firstDomicilio.calle.toUpperCase() : "",
        descripcion: firstDomicilio.descripcion ? firstDomicilio.descripcion.toUpperCase() : "",
        codigo_postal: firstDomicilio.codigo_postal,
        piso: firstDomicilio.piso,
        dpto: firstDomicilio.dpto ? firstDomicilio.dpto.toUpperCase() : "",
        monoblock: firstDomicilio.monoblock ? firstDomicilio.monoblock.toUpperCase() : "",
        barrio: firstDomicilio.barrio ? firstDomicilio.barrio.toUpperCase() : "",
        manzana: firstDomicilio.manzana ? firstDomicilio.manzana.toUpperCase() : "",
        casa: firstDomicilio.casa ? firstDomicilio.casa.toUpperCase() : "",
        localidad: firstDomicilio.localidad ? firstDomicilio.localidad.toUpperCase() : "",
        coordenadas: firstDomicilio.coordenadas,
        id: firstDomicilio.id,
        id_departamento: firstDomicilio.departamento ? firstDomicilio.departamento.toUpperCase() : "",
        id_provincia: firstDomicilio.provincia ? firstDomicilio.provincia.toUpperCase() : "",
        id_pais: firstDomicilio.pais ? firstDomicilio.pais.toUpperCase() : "",
        domicilio_electronico: firstDomicilio.domicilio_electronico,
        domicilio_contractual: firstDomicilio.domicilio_contractual,
        latitud: firstDomicilio.latitud,
        longitud: firstDomicilio.longitud,

      });
  
      setSelectedRow(0); // Marcar la primera fila como seleccionada
    }
  
    const _itemCrud = itemsCrud;
    if (_itemCrud.length > 0) {
      _itemCrud.forEach((item) => {
        item.tipo = item.tipo.toUpperCase();
      });
    }
    setDomicilios(_itemCrud);
  }, [actionCrud, itemCrud, itemsCrud]);
  


  const handleObtienedomicilio = (dataIndex) => {
    setSelectedRow(dataIndex)
    const selectedDomicilio = domicilios[dataIndex]
    setItemCrudLocal({
      tipo: selectedDomicilio.tipo,
      numero_calle: selectedDomicilio.numero_calle,
      calle: selectedDomicilio.calle ? selectedDomicilio.calle.toUpperCase() : "",
      descripcion: selectedDomicilio.descripcion ? selectedDomicilio.descripcion.toUpperCase() : "",
      codigo_postal: selectedDomicilio.codigo_postal,
      piso: selectedDomicilio.piso,
      dpto: selectedDomicilio.dpto ? selectedDomicilio.dpto.toUpperCase() : "",
      monoblock: selectedDomicilio.monoblock ? selectedDomicilio.monoblock.toUpperCase() : "",
      barrio: selectedDomicilio.barrio ? selectedDomicilio.barrio.toUpperCase() : "",
      manzana: selectedDomicilio.manzana ? selectedDomicilio.manzana.toUpperCase() : "",
      casa: selectedDomicilio.casa ? selectedDomicilio.casa.toUpperCase() : "",
      localidad: selectedDomicilio.localidad ? selectedDomicilio.localidad.toUpperCase() : "",
      coordenadas: selectedDomicilio.coordenadas,
      id: selectedDomicilio.id,
      id_departamento: selectedDomicilio.departamento ? selectedDomicilio.departamento.toUpperCase() : "",
      id_provincia: selectedDomicilio.provincia ? selectedDomicilio.provincia.toUpperCase() : "",
      id_pais: selectedDomicilio.pais ? selectedDomicilio.pais.toUpperCase() : "",
      domicilio_electronico: selectedDomicilio.domicilio_electronico,
      domicilio_contractual: selectedDomicilio.domicilio_contractual,
      latitud: selectedDomicilio.latitud,
      longitud: selectedDomicilio.longitud,
    })
  }

  const handleCloseDialog = () => {
    onClose()
  }

  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    })
  }

  const handleSave = () => {
    if (itemCrudLocal.tipo === "" || itemCrudLocal.numero_calle === "") {
      setMessage({
        severity: "error",
        messageText: "Debes completar todos los campos.",
      })
      setShowMessage(true)
      return
    }
    onSave(itemCrudLocal)
  }

  const handleCopyToClipboard = () => {
    const formattedAddress = formatAddress(itemCrudLocal);
    navigator.clipboard
      ?.writeText(formattedAddress)
      .then(() => {
        console.log("Dirección copiada");
        setMessage({
          severity: "success",
          messageText: "Dirección copiada al portapapeles.",
        });
        setShowMessage(true);
      })
      .catch((err) => {
        console.error("Error al copiar la dirección", err);
        setMessage({
          severity: "error",
          messageText: "Error al copiar la dirección.",
        });
        setShowMessage(true);
      });
  };

  const tableColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "tipo",
      label: "Tipo de domicilio",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => (
          <Tooltip title="Ver Domicilio">
            <IconButton size="small" aria-label="view" onClick={() => handleObtienedomicilio(dataIndex)}>
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    },
  ]

  const tableOptions = {
    download: false,
    filter: false,
    print: false,
    search: false,
    viewColumns: false,
    pagination: false,
    elevation: 1,
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
      },
    },
    setRowProps: (row, dataIndex) => ({
      style: {
        backgroundColor: selectedRow === dataIndex ? "#e8f5e9" : "inherit",
      },
    }),
  }

  return (
    <Dialog
      open={true}
      onClose={handleCloseDialog}
      maxWidth="lg"
      fullWidth={true}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {actionCrud === "view" ? "Ver" : "Nuevo"} Domicilio
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "20vh",
            mb: 2,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 3,
              maxWidth: "1200px",
              width: "100%",
              m: "5px",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "20vh",
                mb: 4,
                marginTop: 2,
                overflowX: "auto",
                
              }}
            >
              <MUIDataTable
                title={"Listado de domicilios"}
                columns={tableColumns}
                options={tableOptions}
                data={domicilios? domicilios : []}
              />
            </Box>

            <Grid container spacing={2}>
              {(actionCrud === "view" || actionCrud === "delete") && itemCrudLocal.tipo && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px"}}>Tipo</h3>
                    <TextField sx={{ width: "50%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="tipo"
                      variant="outlined"
                      size="small"
                      name="tipo"
                      value={itemCrudLocal.tipo?.toUpperCase() || ""}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {(actionCrud === "edit" || actionCrud === "new") && (
                <Grid xs={12} md={6} lg={4}>
                  <FormControl fullWidth sx={{ mb: 1 }}>
                    <Autocomplete
                      id="tipo"
                      options={domicilios.map((dom) => dom.tipo)}
                      value={itemCrudLocal.tipo || null}
                      onChange={(event, newValue) => {
                        handleChange({
                          target: {
                            name: "tipo",
                            value: newValue || "",
                          },
                        })
                      }}
                      disabled={actionCrud === "view"}
                      renderInput={(params) => <TextField {...params} label="Tipo de domicilio" size="small" />}
                      ListboxProps={{ style: { maxHeight: "300px" } }}
                    />
                  </FormControl>
                </Grid>
              )}
              {itemCrudLocal.calle && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px"}}>Calle</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="calle"
                      variant="outlined"
                      size="small"
                      name="calle"
                      value={itemCrudLocal.calle}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.numero_calle && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px"}}>Numero</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="numero_calle"
                      variant="outlined"
                      size="small"
                      name="numero_calle"
                      value={itemCrudLocal.numero_calle}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.descripcion && (
                <Grid item xs={12} md={12} lg={12}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Descripción</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="descripcion"
                      variant="outlined"
                      size="small"
                      name="descripcion"
                      value={itemCrudLocal.descripcion === "SIN DATOS DE DOMICILIO" ? "" : itemCrudLocal.descripcion}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              
              {itemCrudLocal.piso && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Piso</h3>
                    <TextField sx={{ width: "30%"}}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="piso"
                      variant="outlined"
                      size="small"
                      name="piso"
                      value={itemCrudLocal.piso}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.dpto && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Dpto</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="dpto"
                      variant="outlined"
                      size="small"
                      name="dpto"
                      value={itemCrudLocal.dpto}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.monoblock && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Monoblock</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="monoblock"
                      variant="outlined"
                      size="small"
                      name="monoblock"
                      value={itemCrudLocal.monoblock}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.barrio && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Barrio</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="barrio"
                      variant="outlined"
                      size="small"
                      name="barrio"
                      value={itemCrudLocal.barrio}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.manzana && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Manzana</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="manzana"
                      variant="outlined"
                      size="small"
                      name="manzana"
                      value={itemCrudLocal.manzana}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.casa && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Casa</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="casa"
                      variant="outlined"
                      size="small"
                      name="casa"
                      value={itemCrudLocal.casa}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {itemCrudLocal.localidad && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px"}}>Localidad</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="localidad"
                      variant="outlined"
                      size="small"
                      name="localidad"
                      value={itemCrudLocal.localidad}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              
              {(actionCrud === "view" || actionCrud === "delete") && itemCrudLocal.id_departamento && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Departamento</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="id_departamento"
                      variant="outlined"
                      size="small"
                      name="id_departamento"
                      value={itemCrudLocal.id_departamento?.toUpperCase() || ""}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {(actionCrud === "edit" || actionCrud === "new") && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl fullWidth sx={{ mb: 1 }}>
                    <Autocomplete
                      id="id_departamento"
                      options={departamentos.map((dep) => dep.nombre)}
                      value={itemCrudLocal.id_departamento || null}
                      onChange={(event, newValue) => {
                        handleChange({
                          target: {
                            name: "id_departamento",
                            value: newValue || "",
                          },
                        })
                      }}
                      disabled={actionCrud === "view"}
                      renderInput={(params) => <TextField {...params} label="Departamento" size="small" />}
                      ListboxProps={{ style: { maxHeight: "300px" } }}
                    />
                  </FormControl>
                </Grid>
              )}
              {(actionCrud === "view" || actionCrud === "delete") && itemCrudLocal.id_provincia && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>Provincia</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="id_provincia"
                      variant="outlined"
                      size="small"
                      name="id_provincia"
                      value={itemCrudLocal.id_provincia?.toUpperCase() || ""}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {(actionCrud === "edit" || actionCrud === "new") && (
                <Grid item xs={12} md={6} lg={4}>
                  <FormControl fullWidth sx={{ mb: 1 }}>
                    <Autocomplete
                      id="id_provincia"
                      options={provincias.map((prov) => prov.nombre)}
                      value={itemCrudLocal.id_provincia || null}
                      onChange={(event, newValue) => {
                        handleChange({
                          target: {
                            name: "id_provincia",
                            value: newValue || "",
                          },
                        })
                      }}
                      disabled={actionCrud === "view"}
                      renderInput={(params) => <TextField {...params} label="Provincia" size="small" />}
                      ListboxProps={{ style: { maxHeight: "300px" } }}
                    />
                  </FormControl>
                </Grid>
              )}
              {(actionCrud === "view" || actionCrud === "delete") && itemCrudLocal.id_pais && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>País</h3>
                    <TextField sx ={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="id_pais"
                      variant="outlined"
                      size="small"
                      name="id_pais"
                      value={itemCrudLocal.id_pais?.toUpperCase() || ""}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
              {(actionCrud === "edit" || actionCrud === "new") && (
                <Grid item xs={12} lg={4}>
                  <FormControl fullWidth sx={{ mb: 1 }}>
                    <Autocomplete
                      id="id_pais"
                      options={paises.map((pa) => pa.nombre)}
                      value={itemCrudLocal.id_pais || null}
                      onChange={(event, newValue) => {
                        handleChange({
                          target: {
                            name: "id_pais",
                            value: newValue || "",
                          },
                        })
                      }}
                      disabled={actionCrud === "view"}
                      renderInput={(params) => <TextField {...params} label="País" size="small" />}
                      ListboxProps={{ style: { maxHeight: "300px" } }}
                    />
                  </FormControl>
                </Grid>
              )}

              {itemCrudLocal.codigo_postal && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box display="flex" alignItems="center">
                    <h3 style={{ marginRight: "10px" }}>CP</h3>
                    <TextField sx={{ width: "30%" }}
                      inputProps={{
                        autoComplete: "off",
                        readOnly: actionCrud === "view",
                      }}
                      id="codigo_postal"
                      variant="outlined"
                      size="small"
                      name="codigo_postal"
                      value={itemCrudLocal.codigo_postal}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>
          
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button variant="contained" color="primary" onClick={handleCopyToClipboard}>
                Copiar domicilio
              </Button>
            </Box>

            <Box sx={{ textAlign: "right", mb: 2, mt: 2 }}>
              {actionCrud !== "view" && (
                <Button sx={{ mr: 1 }} variant="contained" onClick={handleSave} startIcon={<SaveIcon />}>
                  Guardar
                </Button>
              )}
              <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
                {actionCrud === "view" ? "Volver" : "Cancelar"}
              </Button>
            </Box>
          </Paper>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DomiciliosDialog

